import { Box, Skeleton, Stack } from '@rossum/ui/material';

export const LoadingSkeletons = () => (
  <Box p={2}>
    <Stack spacing={1}>
      {Array.from({ length: 10 }, (_, index) => (
        <Skeleton key={index} variant="rectangular" height={52} />
      ))}
    </Stack>
  </Box>
);
